// import React, { useState } from "react";
// import "./ServicesPage.css";
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import "swiper/css/navigation";
// import { Navigation } from "swiper/modules";
// import DestinationWeddingFormModal from "./components/DestinationWeddingFormModal";
// import CorporateTravelFormModal from "./components/CorporateTravelFormModal";

// const travelerServices = [
//   {
//     title: "Luxury Travel Planning",
//     description:
//       "Experience travel in its finest form: luxurious villas, 5-star stays, private transfers and curated premium experiences across the globe.",
//     image: "/luxury.jpg",
//   },
//   {
//     title: "Corporate Travel Planning",
//     description:
//       "Efficient, cost-effective, and stress-free business trips planned with precision for teams or individuals. Meetings to offsites, we handle it all.",
//     image: "/corporate.jpg",
//   },
//   {
//     title: "Hyper-personalized Itineraries",
//     description:
//       "Tell us your travel dreams and we’ll turn them into a seamless, day-by-day plan customized just for you. Based on your budget, preferences, and pace.",
//     image: "/planner.jpg",
//   },
//   {
//     title: "Destination Wedding Planning",
//     description:
//       "Say “I do” somewhere magical. From location scouting to guest stay coordination, we help you plan the perfect destination wedding.",
//     image: "/wedding.jpg",
//   },
//   {
//     title: "Flight Bookings",
//     description:
//       "We help you find the best flight deals, manage changes, and ensure smooth take-offs and landings, always with real-time support.",
//     image: "/flightbookings.jpg",
//   },
//   {
//     title: "Hotel & Stay Reservations",
//     description:
//       "From cozy homestays to luxury resorts, we handpick and book stays that fit your vibe, needs, and budget perfectly!",
//     image: "/hotels.jpg",
//   },
// ];

// const hotelServices = [
//   {
//     title: "Visual Storytelling Kit",
//     description:
//       "Stand out online with a high-quality content package, professional photos, reels, and videos designed to capture your property’s soul.",
//     image: "/storytelling.jpg",
//   },
//   {
//     title: "Micro-Influencer Matchmaking",
//     description:
//       "We connect you with verified travel influencers whose audience matches your target guest profile for real, trackable results.",
//     image: "/vlogger.jpg",
//   },
//   {
//     title: "AI-Driven Guest Insight Report",
//     description:
//       "Understand what your guests love (and what they don’t). Our AI analyses feedback and trends to help you improve and grow.",
//     image: "/ai.jpg",
//   },
//   {
//     title: "Digital Presence Revamp",
//     description:
//       "From website audits to Instagram glow-ups we refine your digital identity to make a bold, consistent impression across platforms.",
//     image: "/insta.jpg",
//   },
//   {
//     title: "TravXplo Verified Hotel Program",
//     description:
//       "Get featured as a trusted stay on our platform. We conduct on-ground checks and offer a Verified Badge that boosts guest trust and bookings.",
//     image: "/verify.jpg",
//   },
//   {
//     title: "Reels & Ad Strategy",
//     description:
//       "We design and deliver short-form video content and ad campaigns that drive visibility, views, and direct bookings.",
//     image: "/reels.jpg",
//   },
//   {
//     title: "Festive Campaign Bundles",
//     description:
//       "Launch targeted holiday offers and seasonal campaigns with our ready-to-go marketing packages designed for festivals and peak seasons.",
//     image: "/festive1.jpg",
//   },
// ];

// const ServicesModalSlider = () => {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [selectedCategory, setSelectedCategory] = useState("");
//   const [showWeddingForm, setShowWeddingForm] = useState(false);
//   const [showCorporateForm, setShowCorporateForm] = useState(false);

//   const openModal = (category) => {
//     setSelectedCategory(category);
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//   };

//   const dataToShow =
//     selectedCategory === "travelers" ? travelerServices : hotelServices;

//   return (
//     <div className="services-wrapper">
//       <div className="services-container split">
//         <div className="left-container">
//           <div className="overlay">
//             <h2>Services</h2>
//             <p>
//               Select your category to explore tailored offerings <b>»</b>
//             </p>
//           </div>
//         </div>

//         <div className="right-container">
//           <div className="right-card-container">
//             <div
//               className="service-card"
//               onClick={() => openModal("travelers")}
//             >
//               <div
//                 className="card-bg"
//                 style={{
//                   backgroundImage: `url(/traveler-card.jpg)`,
//                   backgroundSize: `cover`,
//                 }}
//               />
//               <div className="card-content">
//                 <h3>For Travelers</h3>
//                 <p>Plan your perfect trip with curated travel experiences</p>
//               </div>
//             </div>

//             <div className="service-card" onClick={() => openModal("hotels")}>
//               <div
//                 className="card-bg"
//                 style={{ backgroundImage: `url(/hotel-card.jpg)` }}
//               />
//               <div className="card-content">
//                 <h3>For Hotels & Resorts</h3>
//                 <p>Get powerful tools to manage guests & bookings</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {isModalOpen && (
//         <div className="modal-overlay">
//           <div className="services-modal-content">
//             <button className="close-btn" onClick={closeModal}>
//               ×
//             </button>
//             <Swiper
//               navigation={true}
//               modules={[Navigation]}
//               spaceBetween={30}
//               slidesPerView={1}
//               className="custom-swiper"
//             >
//               {dataToShow.map((service, idx) => (
//                 <SwiperSlide
//                   key={idx}
//                   className="slide-card"
//                   style={{ backgroundImage: `url(${service.image})` }}
//                 >
//                   <div className="slide-overlay">
//                     <h3>{service.title}</h3>
//                     <p>{service.description}</p>

//                     {service.title === "Destination Wedding Planning" && (
//                       <div
//                         style={{
//                           display: "flex",
//                           justifyContent: "center",
//                           marginTop: "24px",
//                         }}
//                       >
//                         <button
//                           onClick={() => {
//                             closeModal();
//                             setShowWeddingForm(true);
//                           }}
//                           style={{
//                             padding: "12px 30px",
//                             fontSize: "16px",
//                             borderRadius: "30px",
//                             backgroundColor: "#1D4ED8",
//                             color: "#fff",
//                             border: "none",
//                             cursor: "pointer",
//                             fontWeight: 600,
//                             boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//                             transition: "transform 0.2s ease-in-out",
//                           }}
//                           onMouseEnter={(e) =>
//                             (e.target.style.transform = "scale(1.05)")
//                           }
//                           onMouseLeave={(e) =>
//                             (e.target.style.transform = "scale(1)")
//                           }
//                         >
//                           💍 Plan My Destination Wedding
//                         </button>
//                       </div>
//                     )}

//                     {service.title === "Corporate Travel Planning" && (
//                       <div
//                         style={{
//                           display: "flex",
//                           justifyContent: "center",
//                           marginTop: "24px",
//                         }}
//                       >
//                         <button
//                           onClick={() => {
//                             closeModal();
//                             setShowCorporateForm(true);
//                           }}
//                           style={{
//                             padding: "12px 30px",
//                             fontSize: "16px",
//                             borderRadius: "30px",
//                             backgroundColor: "#2563EB",
//                             color: "#fff",
//                             border: "none",
//                             cursor: "pointer",
//                             fontWeight: 600,
//                             boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//                             transition: "transform 0.2s ease-in-out",
//                           }}
//                           onMouseEnter={(e) =>
//                             (e.target.style.transform = "scale(1.05)")
//                           }
//                           onMouseLeave={(e) =>
//                             (e.target.style.transform = "scale(1)")
//                           }
//                         >
//                           💼 Plan My Corporate Travel
//                         </button>
//                       </div>
//                     )}
//                   </div>
//                 </SwiperSlide>
//               ))}
//             </Swiper>
//           </div>
//         </div>
//       )}

//       <DestinationWeddingFormModal
//         isOpen={showWeddingForm}
//         onRequestClose={() => setShowWeddingForm(false)}
//       />

//       <CorporateTravelFormModal
//         isOpen={showCorporateForm}
//         onRequestClose={() => setShowCorporateForm(false)}
//       />
//     </div>
//   );
// };

// export default ServicesModalSlider;
import React from "react";
import { Link, useNavigate } from "react-router-dom";

const ServicesPage = () => {
  const navigate = useNavigate();

  const Card = ({ title, description, bgImage, primaryBtn, secondaryBtn }) => {
    const handleCardClick = (e) => {
      if (e.target.tagName !== 'A' && e.target.tagName !== 'BUTTON') {
        navigate("/hotel-partnership");
      }
    };

    return (
      <div 
        onClick={handleCardClick}
        style={{
          position: "relative",
          flex: "1 1 450px", // Standardized card width
          minHeight: "500px", // Reduced height for standard resolution
          borderRadius: "24px",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          padding: "40px 32px", // Standardized internal padding
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          transition: "transform 0.4s ease",
          boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
          cursor: "pointer" 
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-5px)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
        }}
      >
        <div style={{ 
          position: "absolute", 
          inset: 0, 
          background: "linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.3) 60%, rgba(0,0,0,0) 100%)", 
          zIndex: 1 
        }} />
        
        <div style={{ position: "relative", zIndex: 2 }}>
          <h2 style={{ 
            fontFamily: "'Cormorant Garamond', serif", 
            fontSize: "36px", // Reduced from 52px for standard resolution
            fontWeight: "700", 
            color: "#fff", 
            marginBottom: "12px",
            lineHeight: "1.2"
          }}>
            {title}
          </h2>

          <p style={{ 
            fontSize: "18px", // Reduced from 26px for standard resolution
            color: "rgba(255,255,255,0.9)", 
            marginBottom: "30px", 
            lineHeight: "1.5",
            maxWidth: "400px",
            fontFamily: "'Cormorant Garamond', serif"
          }}>
            {description}
          </p>
          
          <style>
            {`
              @media (min-width: 769px) {
                .btn-container { flex-direction: row !important; }
                .btn-container a { flex: 1; text-align: center; }
              }
              @media (max-width: 768px) {
                .btn-container { flex-direction: column !important; }
                .btn-container a { width: 100%; text-align: center; }
              }
              .premium-btn {
                padding: 12px 20px; /* Reduced from 18x32 for standard sizing */
                background-color: transparent;
                color: #fff;
                border: 2px solid #fff;
                border-radius: 50px;
                text-decoration: none;
                font-weight: 700;
                font-size: 15px; /* Reduced from 20px for standard sizing */
                font-family: 'Cormorant Garamond', serif;
                transition: all 0.3s ease;
                backdrop-filter: blur(5px);
                display: inline-block;
                letter-spacing: 0.5px;
                position: relative;
                z-index: 3;
              }
              .premium-btn:hover {
                background-color: #fff !important;
                color: #111827 !important;
                transform: translateY(-2px);
              }
            `}
          </style>

          <div className="btn-container" style={{ display: "flex", gap: "12px" }}>
            <Link to={primaryBtn.route} className="premium-btn">
              {primaryBtn.label}
            </Link>

            <Link to={secondaryBtn.route} className="premium-btn">
              {secondaryBtn.label}
            </Link>
          </div>
        </div>
      </div>
    );
  };

  return (
    <section 
      id="planner" 
      style={{ 
        padding: "100px 24px", // Standard section padding
        position: "relative",
        backgroundImage: "url('services/travel-agency14.jpg')",
        backgroundSize: "cover",
        backgroundAttachment: "fixed",
        backgroundPosition: "center"
      }}
    >
      <div style={{ position: "absolute", inset: 0, backgroundColor: "rgba(0, 0, 0, 0.4)", zIndex: 0 }} />

      <div style={{ position: "relative", zIndex: 1, maxWidth: "1100px", margin: "0 auto" }}>
        <header style={{ textAlign: "center", marginBottom: "60px" }}>
          <h1 style={{ 
            fontFamily: "'Cormorant Garamond', serif", 
            fontSize: "52px", // Standardized heading
            fontWeight: 'bold', 
            color: "#fff", 
            marginBottom: "10px",
            lineHeight: "1.2" 
          }}>
            Choose Your Path
          </h1>
          <p style={{ 
            fontSize: "24px", // Reduced from 28px
            fontWeight: '600',
            color: "#fff", 
            opacity: 0.9,
            fontFamily: "'Cormorant Garamond', serif"
          }}>
            Explore how TravXplo can help you.
          </p>
        </header>

        <div style={{ display: "flex", gap: "40px", flexWrap: "wrap", justifyContent: "center" }}>
          <Card
            title="For Travelers"
            description="Plan trips, explore destinations, and get expert help for your journey."
            bgImage="services/young-female-traveler-enjoying-rural-surroundings_23-2149125532.avif"
            primaryBtn={{ label: "Generate Free Itinerary", route: "/PricingPlans" }}
            secondaryBtn={{ label: "Plan My Trip", route: "/plan-your-trip" }}
          />

          <Card
            title="For Hotels & Resorts"
            description="Partner with TravXplo to grow visibility, trust, and traveler reach."
            bgImage="services/hotel.jpg"
            primaryBtn={{ 
                label: "Influencer Collaborations", 
                route: "/hotel-partnership#influencer-program" 
            }}
            secondaryBtn={{ 
                label: "TravXplo Verified Program", 
                route: "/hotel-partnership#verified-program" 
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default ServicesPage;